import { useMediaQuery } from "beautiful-react-hooks";
import React, { useMemo, useState } from "react";
import { Trans } from "@lingui/macro";
import Button from "../../../components/Button";
import { Icon } from "../../../components/Icon";
import { isSSR } from "../../../components/NoSSR";
import Popup from "../../../components/Popup";
import bannerOnDemand from "../assets/bannerOnDemand.png";
import "./WelcomePopup.css";
import sendEvent, { sendFacebookEvent } from "../../../functions/analytics";

export function WelcomePopup() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isMobile = !isSSR && useMediaQuery("(max-width: 767px)");
  const [open, setOpen] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const popupTheme = useMemo(() => (isMobile ? "bottomSheet" : "appearing"), [isMobile]);

  const handleClosePopup = () => {
    setOpen(false);
    sendEvent("track", "on_demand_create_click");
    sendFacebookEvent("track", "on_demand_create_click");
  };

  return (
    <Popup
      closable
      hideHeader="true"
      open={open}
      theme={popupTheme}
      className="welcome-popup"
      onClosed={handleClosePopup}
    >
      <div className="welcome-popup__content">
        <div>
          <img
            src={bannerOnDemand}
            className={`welcome-popup__image ${imageLoaded ? "loaded" : ""}`}
            onLoad={() => setImageLoaded(true)}
          />
          <p className="welcome-popup__description">
            <h2 className="welcome-popup__description_title">
              <Trans>Your Personal Tour</Trans>
            </h2>
            <span className="welcome-popup__description_subtitle">
              <Trans>Create a tour anywhere based on your interests</Trans>
            </span>
          </p>
        </div>
        <ul className="welcome-popup__list">
          <li>
            <Icon name="location/pin" width="24" height="24" />
            <Trans>
              Navigate effortlessly with a live GPS <br /> map on your phone
            </Trans>
          </li>
          <li>
            <Icon name="attraction" width="24" height="24" />
            <Trans>
              Enjoy audio stories and facts about <br /> each attraction
            </Trans>
          </li>
          <li>
            <Icon name="globe-language" width="24" height="24" />
            <Trans>Multi-Language support</Trans>
          </li>
          <li>
            <Icon name="friends" width="24" height="24" />
            <Trans>Unlimited sharing with friends</Trans>
          </li>
        </ul>

        <Button theme="black" className="welcome-popup__button" size="L" onClick={handleClosePopup}>
          <Icon name="magic-stars" /> <Trans>Create Tour</Trans>
        </Button>
      </div>
    </Popup>
  );
}
